import { render, staticRenderFns } from "./TraxUiCardPlainHeader.vue?vue&type=template&id=8228e642"
import script from "./TraxUiCardPlainHeader.vue?vue&type=script&lang=js"
export * from "./TraxUiCardPlainHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports